import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa";

function PaymentSuccess() {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState("Verifying payment...");
    const [credits, setCredits] = useState(0);
    const sessionId = searchParams.get("session_id");
    const navigate = useNavigate();

    useEffect(() => {
        const verifyPayment = async () => {
            try {
                const response = await axios.post(process.env.REACT_APP_API_URL+"/verify-payment", {
                    sessionId,
                });

                if (response.data.success) {
                    setStatus("✅ Payment confirmed! Credits have been added to your account.");
                } else {
                    setStatus("❌ Payment verification failed. Please contact support.");
                }
                setCredits(response.data.planCredits);
            } catch (err) {
                console.error(err);
                setStatus("❌ An error occurred during verification.");
            }
        };

        if (sessionId) {
            verifyPayment();
        } else {
            setStatus("❌ Missing session ID.");
        }
    }, [sessionId]);

    return (
        <div className="payment-success-container">
            <div className="success-card">
                <div className="icon">
                    🎉
                </div>
                <h2>Payment Success</h2>
                <p className="confirmation">
                    {status}
                </p>
                <p className="credits-text">✅ {credits} credits added</p>

                <button className="home-btn" onClick={() => navigate("/")}>
                    <FaArrowLeft style={{ marginRight: "8px" }} />
                    Back to Home
                </button>
            </div>
        </div>
    );
}

export default PaymentSuccess;